import { render, staticRenderFns } from "./BookedCusList.vue?vue&type=template&id=3c45a9cd"
import script from "./BookedCusList.vue?vue&type=script&lang=js"
export * from "./BookedCusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports